var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-cart"},[_c('svg',{attrs:{"fill":"none"}},[_c('use',{attrs:{"xlink:href":"#EmptyCart"}})]),_c('div',{staticClass:"empty-content"},[_c('h5',[_vm._v(_vm._s(_vm._T("Oops, You have no item")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }